import { useState, useEffect, useRef } from 'react';
import { Typography, Table, TableBody, TableRow, TableCell, Paper } from '@mui/material';
import moment from 'moment';
import colors from 'assets/theme/base/colors';

const CommonDetails = ({ sharedValue }: any) => {
	const dataFetchedRef = useRef(false);

	const [model, setModel] = useState(sharedValue);

	useEffect(() => {
		if (dataFetchedRef.current) return;
		dataFetchedRef.current = true;
		setModel(sharedValue);
	}, [sharedValue]);
	return (
		<Paper elevation={8} className="width-65"
			sx={{
			"&.MuiPaper-root": {
				padding: '16px !important',
				backgroundColor: `${colors.backgroundLight.dark} !important`,
			},
		}}
		>
			<Typography variant="subHeader" component="h6" mb={2}>
				Common Details
			</Typography>
			<Table className="model-overview-table" >
				<TableBody>
					<TableRow>
						<TableCell
						className="attrTitle"
						sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}
						>
						<Typography variant="bodyText">Model Name</Typography>
						</TableCell>
						<TableCell
						className="attrValue"
						sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}
						>
						<Typography variant="bodyText">{model?.name}</Typography>
						</TableCell>
						<TableCell
						className="attrTitle"
						sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}
						>
						<Typography variant="bodyText">Last Updated on</Typography>
						</TableCell>
						<TableCell
						className="attrValue"
						sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}
						>
						<Typography variant="bodyText">
							{model?.updatedAt &&
							`${moment(model.updatedAt).format()} ${
								moment().isDST() ? '(UTC-4)' : '(UTC-5)'
							}`}
						</Typography>
						</TableCell>
					</TableRow>

					<TableRow>
						<TableCell
						className="attrTitle"
						sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}
						>
						<Typography variant="bodyText">Sector</Typography>
						</TableCell>
						<TableCell
						className="attrValue"
						sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}
						>
						<Typography variant="bodyText">{model?.sector}</Typography>
						</TableCell>
						<TableCell
						className="attrTitle"
						sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}
						>
						<Typography variant="bodyText">Training Date</Typography>
						</TableCell>
						<TableCell
						className="attrValue"
						sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}
						>
						<Typography variant="bodyText">
							{model?.training_date && moment(model.training_date).format()}
						</Typography>
						</TableCell>
					</TableRow>

					<TableRow>
						<TableCell
						className="attrTitle"
						sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}
						>
						<Typography variant="bodyText">Model Type</Typography>
						</TableCell>
						<TableCell
						className="attrValue"
						sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}
						>
						<Typography variant="bodyText">{model?.model_type}</Typography>
						</TableCell>
						<TableCell
						className="attrTitle"
						sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}
						>
						<Typography variant="bodyText">Version</Typography>
						</TableCell>
						<TableCell
						className="attrValue"
						sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}
						>
						<Typography variant="bodyText">{model?.version}</Typography>
						</TableCell>
					</TableRow>
				</TableBody>
			</Table>
		</Paper>
	);
};

export default CommonDetails;
